import React from "react";
import "../css/Loading.css";

function Loading() {
  return (
    <div className='loading'>
      <h2 className='animate'>Welcome to my portfolio</h2>
    </div>
  );
}

export default Loading;
